import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useRoomUtilizationRankingStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  toggleRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0',
    marginBottom: tokens.spacingVerticalM,
  },
  toggleButton: {
    ...shorthands.borderRadius(0),
    minWidth: '80px',
  },
  toggleButtonFirst: {
    borderTopLeftRadius: tokens.borderRadiusMedium,
    borderBottomLeftRadius: tokens.borderRadiusMedium,
  },
  toggleButtonLast: {
    borderTopRightRadius: tokens.borderRadiusMedium,
    borderBottomRightRadius: tokens.borderRadiusMedium,
  },
});
